<!--
 * @Description  : 
 * @Author       : XiaoLei
 * @Date         : 2021-04-07 13:47:28
 * @LastEditTime : 2025-11-05 16:10:23
 * @LastEditors  : BigBigger
-->
<template>
  <div class="course-info">
    <div class="title">个人信息</div>
    <div class="userInfo">
      <div class="info-box">
        <div class="infoList">
          <span class="in-label in-label-req">真实姓名</span>
          <van-field
            clearable
            v-model="realName"
            placeholder="请输入真实姓名"
          />
        </div>
        <div class="infoList">
          <span class="in-label in-label-req">电话</span>
          <van-field clearable v-model="phone" placeholder="请输入手机号码" />
        </div>
        <div class="infoList">
          <span class="in-label  in-label-req">年级</span>
          <van-field
            readonly
            clickable
            :value="remark1"
            placeholder="选择年级"
            @click="showRemark1 = true"
          />
        </div>
        <div class="infoList">
          <span class="in-label  in-label-req">学院</span>
          <van-field
            readonly
            clickable
            :value="remark2"
            placeholder="选择学院"
            @click="showRemark2 = true"
          />
        </div>
        <div class="infoList">
          <span class="in-label">备注</span>
          <van-field
            clearable
            v-model="remark"
            placeholder="如有特殊要求，请备注"
          />
        </div>
      </div>
    </div>
    <van-popup v-model="showRemark1" round position="bottom">
      <van-picker
        show-toolbar
        :columns="['23级','24级','25级']"
        @cancel="showRemark1 = false"
        @confirm="remark1Confirm"
      />
    </van-popup>
    <van-popup v-model="showRemark2" round position="bottom">
      <van-picker
        show-toolbar
        :columns="['金融贸易学院','管理学院','国际学院','传媒与设计艺术学院','信息工程学院','体育健康学院']"
        @cancel="showRemark2 = false"
        @confirm="remark2Confirm"
      />
    </van-popup>
  </div>
</template>
<script>
import { getPersonalInfo, getUserInfo } from "@/api/api.js";
export default {
  name: "info",
  data() {
    return {
      interviewFlag: null,
      courseInfo: null,
      realName: "",
      gender: 1,
      phone: "",
      idCard: "",
      address: "",
      totalScore: "",
      ranking: "",
      lowestScore: "",
      newStudent: 1,
      admissionTicket: "",
      school: "",
      profession: "",
      freshStudent: 1,
      field02: "",
      remark: "",
      isZJ: process.env.VUE_APP_AREA === "zj" ? true : false,
      // 是否为面试体验课
      trialClass: true,
      // 是否是选调生面试
      isShowLowestScore: true,
      columns: [
        { text: "省考", value: "省考" },
        { text: "国考", value: "国考" },
        { text: "事业单位", value: "事业单位" },
        { text: "国考、省考都已参加", value: "国考、省考都已参加" },
      ],
      alipayPhone: "",
      testType: "选调生",
      showRemark2: false,
      showRemark1: false,
      remark1: "",
      remark2: "",
    };
  },
  computed: {
    isWZSXY() {
      return this.$route.query.isWZSXY === "1";
    }
  },
  mounted() {
    this.getCourseInfo();
  },
  methods: {
    async getPersonalInfo() {
      let response = await getPersonalInfo();
      if (+response.returnCode !== 10001) {
        this.$toast(response.returnMsg);
        return false;
      }
      if (response.data) {
        response.data.totalScore = "";
        response.data.ranking = "";
        response.data.lowestScore = "";
        response.data.admissionTicket = "";
        this.setDefaultInfo(response.data);
      } else {
        getUserInfo().then((res) => {
          this.phone = res.data.phone;
        });
      }
    },
    check() {
      if (!this.realName) {
        this.$toast("请填写姓名");
        return false;
      }
      if (!this.phone) {
        this.$toast("请填写手机号");
        return false;
      }
      if (
        !/^(13[0-9]|14[01456879]|15[0-3,5-9]|16[2567]|17[0-8]|18[0-9]|19[0-3,5-9])\d{8}$/.test(
          this.phone
        )
      ) {
        this.$toast("手机号格式错误");
        return false;
      }
      if(!this.remark1){
        this.$toast('请选择年级')
        return false
      }
      if(!this.remark2){
        this.$toast('请选择学院')
        return false
      }
      this.$store.dispatch("setOrderInfo", {
        ...this.$store.state.orderInfo,
        loUserInfo: {
          ...this.$store.state.orderInfo.loUserInfo,
          realName: this.realName,
          gender: this.gender,
          phone: this.phone,
          idCard: this.idCard,
          address: this.address,
          totalScore: this.totalScore,
          ranking: this.ranking,
          lowestScore: this.lowestScore,
          newStudent: this.newStudent,
          admissionTicket: this.admissionTicket,
          school: this.school,
          profession: this.profession,
          freshStudent: this.freshStudent,
          remark: this.remark,
          field02: this.field02,
          testType: this.testType,
          alipayPhone: this.alipayPhone,
          remark1: this.remark1,
          remark2: this.remark2,
        },
      });
      return true;
    },
    setDefaultInfo(defaultInfo) {
      this.realName = defaultInfo.realName;
      this.gender = defaultInfo.gender || 1;
      this.phone = defaultInfo.phone;
      this.remark = defaultInfo.remark;
      this.alipayPhone = defaultInfo.alipayPhone;
      this.testType = defaultInfo.testType || "选调生";
      this.remark1 = defaultInfo.remark1;
      this.remark2 = defaultInfo.remark2;
      if (this.interviewFlag === 3) {
        this.school = defaultInfo.school;
      }
      if (this.interviewFlag === 1) {
        this.idCard = defaultInfo.idCard;
        this.address = defaultInfo.address;
        this.totalScore = defaultInfo.totalScore;
        this.ranking = defaultInfo.ranking;
        this.lowestScore = defaultInfo.lowestScore;
        this.newStudent = defaultInfo.newStudent || 1;
        this.admissionTicket = defaultInfo.admissionTicket;
        this.school = defaultInfo.school;
        this.profession = defaultInfo.profession;
      }
      this.freshStudent = defaultInfo.freshStudent || 1;
    },
    getCourseInfo() {
      let orderInfo = this.$store.state.orderInfo || null;
      if (orderInfo) {
        this.courseInfo = orderInfo.loCourseInfo;
        this.interviewFlag = this.courseInfo.interviewFlag;
        if (this.courseInfo.loUserInfo) {
          this.setDefaultInfo(this.courseInfo.loUserInfo);
        } else {
          this.getPersonalInfo();
        }
      } else {
        this.courseInfo = null;
        this.getPersonalInfo();
      }
    },
    remark1Confirm(val) {
      this.remark1 = val;
      this.showRemark1 = false;
    },
    remark2Confirm(val) {
      this.remark2 = val;
      this.showRemark2 = false;
    }
  },
};
</script>
<style lang="less" scoped>
.course-info{
  /* width:94%; */
  padding:0 3%;
  background:#fff;
  margin-top: 0.3em;
}
.course-info .title{
  font-size: 16px;
  font-weight: bold;
  text-align: left;
  line-height: 0.5rem;
  padding:0.2rem 0;
  border-bottom:1px #f2f2f5 solid;
}
.userInfo {
  background: #f3f3f3;
}
.info-box {
  //   width:94%;
  padding: 0 3%;
  background: #fff;
  // margin-bottom: 0.25rem;
}
.userInfo .infoList {
  display: flex;
  font-size: 14px;
  color: #5b6b73;
  line-height: 1rem;
  text-align: left;
  // margin:0.15rem 0;
  border-bottom: 1px #f2f2f5 solid;
  display: flex;
  align-items: center;
}
.userInfo .infoList span {
  width: 30%;
}
.userInfo .infoList input[type="text"] {
  color: #333;
}
.userInfo .infoList .info-right input[type="radio"] {
  width: 0.22rem;
  height: 0.22rem;
  margin-right: 0.05rem;
}
.userInfo .infoList .info-right input[type="radio"]:before {
  width: 0.22rem;
  height: 0.22rem;
}
input[type="radio"]:checked:after {
  top: 0.08rem;
  left: 0.05rem;
}
.userInfo .infoList .info-right label {
  margin-right: 0.3rem;
}
.write-rank {
  border-bottom: 1px #f2f2f5 solid;
}
.write-rank .infoList {
  border: none;
}
.write-rank p {
  color: #5b6b73;
  font-size: 12px;
  padding-bottom: 0.2rem;
}
.saveInfo {
  width: 100%;
  height: 1.4rem;
  background: #fff;
  position: fixed;
  bottom: 0;
  /* padding:0.3rem 0; */
}
.saveInfo .saveBtn {
  width: 94%;
  height: 0.8rem;
  line-height: 0.8rem;
  background: #ff3f47;
  font-size: 14px;
  color: #fff;
  font-weight: bold;
  text-align: center;
  border-radius: 10px;
  margin: 0.3rem 3%;
}
.info-box {
  font-size: 14px;
}
.in-label {
  padding-left: 0.1rem;
}
.in-label-req::before {
  display: inline-block;
  content: "*";
  color: #ff3f47;
}
.van-dropdown-menu {
  width: 100%;
}
::v-deep .van-dropdown-menu__bar {
  box-shadow: none !important;
}
::v-deep .van-dropdown-menu__item {
  justify-content: start !important;
  -webkit-justify-content: start;
}
</style>
